<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title">Bienvenido</h4>
    </div>
    <div class="card-content">
      <div class="row">
        <div class="col-md-12">
          <h5>Declaración Patrimonial</h5>
        </div>
        <div class="col-md-12" >
          <div class="alert alert-info" v-if="this.getKey('status_dec') == 0">
            <span>No tienes declaraciones pendientes</span>
          </div>
          <div class="alert alert-info" role="alert" v-if="this.getKey('status_dec') == 0">
            ¿Tienes alguna aclaración que hacer sobre tu declaracion patrimonial?, <a href="javascript:void(0)" class="alert-link" @click="aclaraciones"> agrégala aquí.</a>
          </div>
          <div class="alert alert-warning" role="alert" v-if="!hasfiscal && this.getKey('status_dec') == 0">
            Si omitiste anexar el acuse de presentación de la declaración fiscal, <a href="javascript:void(0)" class="alert-link" @click="fiscal"> agrégalo aquí.</a>
          </div>

          <div>
            <!-- <div class="modal-backdrop fade in"></div> -->
            <!-- Modal -->
            <div class="modal fade " ref="modalAviso" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">AVISO DE PRIVACIDAD SIMPLIFICADO </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <p style="text-align:center"><b>Dirección de Enlace e Información de la
                        Dirección General de Asuntos Jurídicos de la
                        Secretaría de la Transparencia y Rendición de Cuentas
                      </b></p>
                    <p style="text-align:center"><b>
                        AVISO DE PRIVACIDAD SIMPLIFICADO
                      </b></p>
                    <p style="text-align:center"><b>Sistema DeclaraNet Guanajuato, para la recepción de la Declaración de Situación
                        Patrimonial, de Intereses y Constancia de presentación de la declaración fiscal
                      </b></p>
                    <p>
                      Con fundamento en lo dispuesto en los artículos 3 fracción I, 34, 36, 37, 38, 39, 40 y 42, así como lo dispuesto en el Título Tercero, Capítulo Primero de la Ley de Protección de Datos Personales en Posesión de los Sujetos obligados para el Estado de Guanajuato, se hace de su conocimiento lo siguiente: </p>
                    <p><b>
                        DENOMINACIÓN Y FUNDAMENTO LEGAL DE LA RESPONSABLE.
                      </b></p>
                    <p>
                      La Secretaría de la Transparencia y Rendición de Cuentas del Estado de Guanajuato, por conducto de la Dirección de Enlace e Información, adscrita a la Dirección General de Asuntos Jurídicos, es la unidad encargada de administrar y operar el sistema de evolución patrimonial, de declaración de intereses y constancia de presentación de declaración fiscal de las personas servidoras públicas de la Administración Pública del Estado de Guanajuato, así como de verificar aleatoriamente el contenido de las declaraciones patrimoniales, de conflicto de intereses y constancias de presentación de declaración fiscal de las personas servidoras públicas, y realizar las acciones que resulten necesarias para remitir en su caso, al Órgano Interno de Control o autoridad investigadora competente, conforme a lo establecido en la Ley de Responsabilidades, para que determinen lo conducente. Lo anterior con fundamento en lo dispuesto en el Título Segundo, Capítulo Tercero, Secciones
                      Primera, Segunda, Tercera y Sexta de la Ley de Responsabilidades Administrativas para el Estado de Guanajuato; artículos 3, 13 fracción X y 32 fracciones I inciso h), VI inciso d) y VII, de la Ley Orgánica del Poder Ejecutivo para el Estado de Guanajuato; artículos 4, fracción I inciso b numeral b.5 y 18 fracciones I, II, III, IV, VII y VIII, del Reglamento Interior de la Secretaría de la Transparencia y Rendición de Cuentas, es la responsable del tratamiento de los datos personales que nos proporcione. </p>
                    <p><b>
                        FINALIDAD DEL TRATAMIENTO DE DATOS PERSONALES.
                      </b></p>
                    <p>
                      Los datos personales que se recaban, se utilizaran para las siguientes finalidades:
                    <p>1. Integrar y actualizar el padrón de personas servidoras públicas de la Administración Pública del Estado.</p>
                    <p>2. Recibir y registrar las declaraciones de situación patrimonial y de intereses, e integrar el acuse de la presentación de la declaración fiscal de las personas servidoras públicas de las Dependencias y/o Entidades de la Administración Pública Estatal.</p>
                    <p>3. Proporcionar la información de las declaraciones de situación patrimonial y de intereses de los servidores públicos de las Dependencias y/o Entidades de la Administración Pública Estatal a la Plataforma Digital Estatal del Sistema Estatal Anticorrupción y Plataforma Digital Nacional del Sistema Nacional Anticorrupción.</p>
                    <p>4. Proporcionar en versión pública la información de las declaraciones de situación patrimonial y de intereses de los servidores públicos de las Dependencias y/o Entidades de la Administración Pública Estatal, a fin de que sean publicadas en la Plataforma Nacional de Transparencia y Plataforma Estatal de Transparencia, en cumplimiento de lo dispuesto en el artículo 70 fracción XII de la Ley General de Transparencia y Acceso a la Información Pública y artículo 26 fracción XII de la Ley de Transparencia y Acceso a la Información Pública para el Estado de Guanajuato, respectivamente.</p>
                    <p>5. Resguardar y custodiar de la información de las declaraciones de situación patrimonial y de intereses de los servidores públicos de las Dependencias y/o Entidades de la Administración Pública del Estado.</p>
                    <p>6. Verificar de manera aleatoria el contenido de las declaraciones patrimoniales, de conflicto de intereses y constancias de presentación de declaración fiscal de las personas servidoras públicas, que obren en el sistema de declaración patrimonial, así como de la evolución del patrimonio de los servidores públicos, y realizar las acciones que resulten necesarias para remitir en su caso, al Órgano Interno de Control o Autoridad Investigadora competente, conforme a lo dispuesto en la Ley de Responsabilidades, para que determinen lo conducente.</p>
                    <p>7. Dar seguimiento a la presentación de la declaración patrimonial y de intereses, para la detención de los servidores públicos que omitieron presentarla o lo hicieron de forma extemporánea.</p>
                    <p>8. Integrar expedientes de investigación y/o de responsabilidad en el marco de la Ley de Responsabilidades Administrativas para el Estado de Guanajuato, para sustanciar y resolver faltas administrativas de los servidores públicos.</p>
                    <p>9. Proporcionar información en función de las solicitudes formuladas por el Ministerio Público, los Tribunales o las Autoridades judiciales en el ejercicio de sus respectivas atribuciones, el servidor público interesado o bien, cuando las Autoridades investigadoras, substanciadoras o resolutoras lo requieran con motivo de la investigación o la resolución de procedimientos de responsabilidades administrativas, en términos de lo dispuesto por el artículo 28 de la Ley de Responsabilidades Administrativas para el Estado de Guanajuato.</p>

                    <p>Para las finalidades antes señaladas, solicitamos los siguientes datos personales: nombre completo, fecha de nacimiento, sexo, Registro Federal de Contribuyentes (RFC), Clave Única de Registro de Población (CURP), estado civil, lugar de nacimiento (país, entidad federativa), nacionalidad, domicilio actual (país, entidad federativa, municipio, calle, número exterior, número interior, código postal, localidad o colonia), número de teléfono personal, correo electrónico personal, información financiera, datos e información relacionada con el patrimonio, datos curriculares y laborales, información de particulares y terceros relacionados con la persona servidora pública e información adicional que la persona servidora pública desee manifestar en su declaración de situación patrimonial.</p>

                    <p>Se informa que no es necesario recabar su consentimiento para el tratamiento de sus datos personales, en términos de los artículos 8 y 19 fracciones I y V de la Ley de Protección de Datos Personales en Posesión de Sujetos Obligados.

                    </p>
                    <p><b>
                        TRANSFERENCIA DE DATOS PERSONALES.
                      </b></p>
                    <p>
                      Se hace de su conocimiento que sus datos personales podrán ser transferidos a otros sujetos obligados, siempre y cuando, los datos se utilicen para el ejercicio de sus facultades, además de otras transmisiones previstas en la Ley, en términos de lo previstos en los artículos 19, 96, 97, 98, 99, 100 y 101, de la Ley de Protección de Datos Personales en Posesión de Sujetos Obligados, o cuando, previamente se haya obtenido su consentimiento expreso por escrito o por un medio de autenticación similar.
                    </p>
                    <p><b>
                        MECANISMOS Y MEDIOS DISPONIBLES para que el titular pueda manifestar su negativa para el tratamiento de sus datos personales para finalidades y transferencias de datos personales que requieren el consentimiento del titular.
                      </b></p>
                    <p>
                      La protección de sus datos personales es un derecho vinculado a la protección de su privacidad. La Ley establece los medios para controlar el uso ajeno y destino de su información personal, con el propósito de impedir su tráfico ilícito y la potencial vulneración de su dignidad.

                      Si desea manifestar su negativa para el tratamiento de datos personales para finalidades y transferencias de datos personales que requieren el consentimiento del titular, es necesario que dicha manifestación se realice mediante escrito, el cual deberá presentarse ante la Unidad de Transparencia y Archivo del Poder Ejecutivo del Estado de Guanajuato, ubicada en San Sebastián número 78 zona Centro, en Guanajuato, Guanajuato, código postal 36000, número telefónico (473) 688 04 70 extensión 601, de lunes a viernes de las 08:30 a las 16:00 horas, o bien, a través del correo electrónico unidadtransparencia@guanajuato.gob.mx.
                    </p>
                    <p><b>
                        EL SITIO DONDE SE PODRÁ CONSULTAR EL AVISO DE PRIVACIDAD INTEGRAL.
                      </b></p>
                    <p>
                      El aviso de privacidad integral podrá ser consultado en la página institucional de internet de la Secretaría de la Transparencia y Rendición de Cuentas: <a href="http://strc.guanajuato.gob.mx/"> http://strc.guanajuato.gob.mx/ </a>
                    </p>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12" v-if="this.getKey('status_dec') == 1">
          <div class="alert alert-warning" v-for="(dec, i) in this.getKey('tipo_dec_list')" :key="i">
            <!-- <span>Tienes una declaración {{this.getKey('tipo_dec')}} pendiente</span> -->
            <span> Tienes una declaración <b>{{ tipoD(dec.tipo_dec_id) }}</b> pendiente del <b>{{ dec.periodo }}</b> en <b>{{ getDep(dec.ente_publico_id) }}</b></span>
            <!-- <span v-if="this.getKey('tipo_dec_list').length == 1">Tienes una declaración {{this.getKey('tipo_dec')}} pendiente</span> -->
            <!-- <span v-else>Debes presentar una declaración {{this.getKey('tipo_dec')}} y posteriormente una Final</span> -->
          </div>
          <div class="text-center">
            <button class="btn btn-success btn-wd" @click="irLlenado">Ir a llenado</button>
          </div>
        </div>
        <div class="col-md-12" v-if="false">
          <div class="alert alert-danger">
            <span>La fecha limíte para presentar tu declaración ha expirado</span>
          </div>
          <div class="text-center">
            <button class="btn btn-success btn-wd">Solicitar prórroga</button>
          </div>
        </div>
        <div class="col-md-12">
        <div class="text-center">
            <button class="btn btn-success" @click="irHistorico">Consultar Historial</button>
          </div>
          </div>
          <div class="col-md-12">
          <div class="text-center">
            <!-- Button trigger modal -->
            <button ref="btnPrivacidad" type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalLong">
              Consulta el aviso de privacidad
            </button>
          </div>
          </div>
      </div>

      <br>
      <br>

    </div>
  </div>
</template>
<script>
import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
import Loading from 'src/components/Dashboard/Layout/LoadingMainPanel.vue'
import chartist_tooltip from 'chartist-plugin-tooltips'

export default {
  components: {
    StatsCard,
    ChartCard,
    CircleChartCard
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data () {
    return {
      $Chartist: null,
      obligados: '',
      min: 0,
      max: 0,
      faltantes: '',
      porcentaje: 0,
      declaraciones: '',
      plugins: null,
      hasfiscal: false
    }
  },
  methods: {
    tipoD (tipo) {
      switch (tipo) {
        case 1:
          return 'Inicial'
        case 2:
          return 'Anual'
        case 3:
          return 'Final'
      }
    },
    getDep (id) {
      let dep = this.dependencias.find(m => m.id == id)
      if (dep) {
        return dep.valor
      }
      return ''
    },
    irLlenado () {
      this.$router.push('/forms/infPersonal')
    },
    fiscal () {
      // this.$router.push('/forms/fiscal');
      this.$router.push('fiscal')
    },
    aclaraciones () {
      this.$router.push('/forms/aclaraciones')
    },
    irHistorico () {
      this.$router.push('/forms/historico')
    }

  },
  created () {
    if (!(this.getKey('status_dec')) == 1) {
      localStorage.setItem('std', 0)
    }

    this.$http.get('hasfiscal/' + this.getKey('uid')).then(
      response => {
        if (response.data.files) {
          this.hasfiscal = true
        }
      },
      error => {
        console.log(error)
        // this.Err(error)
      }
    )
  },
  mounted () {
    this.$refs.btnPrivacidad.click()
    // console.log(this.$refs.modalAviso)
    document.body.appendChild(this.$refs.modalAviso)
    this.checkCatalogs()
    // this.$refs.modalAviso
  }

}

</script>
<style>
.chartist-tooltip {
  position: absolute !important;
  background: rgba(0, 0, 0, 0.6) !important;
  color: white !important;
  padding: 0px 10px !important;
  border-radius: 5px !important;
}

.titulos {
  text-align: left !important;
}

.modal-backdrop {
  z-index: 1040 !important;
}

.modal-content {
  margin: 2px auto;
  z-index: 1100 !important;
}

.modal-backdrop {
  /* bug fix - no overlay */
  /* display: none; */
}
.modal{z-index: 1060 !important;}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/TableroDec.vue